import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Cookies from 'js-cookie'
import Api from '@/utils/api.js'
import common from '@/utils/common.js'

import VueI18n from 'vue-i18n'
import FBSignInButton from 'vue-facebook-signin-button'
import GSignInButton from "vue-google-signin-button"

import 'animate.css/animate.min.css';

import mixin from '@/components/mixin/mixin.js';//全局引入函数

Vue.mixin(mixin)//全局引入函数
Vue.use(GSignInButton);
Vue.use(FBSignInButton)
Vue.use(VueI18n) // 挂载
// lang==>1 英文
// lang==>2 中文
let lang = Cookies.get('lang')
// console.log('lang',lang)

let locale
if (!lang ||lang ==2) {
  Cookies.set("lang", '2')
  locale = 'zh-CN'
}
if(lang == 1){
  locale = 'en-US'
}


const i18n = new VueI18n({
  locale: locale,    // 语言标识
  messages: {
    'zh-CN': require('@/utils/langs/zh'),   // 中文版cn.js文件路径
    'en-US': require('@/utils/langs/en')    // 英文版en.js文件路径
  }
})


// 页面title切换
for(var i in router.options){
	for(var k in router.options[i]){
		document.title = `${i18n.t('m.title')}`
	}
}

// console.log(i18n)



Vue.use(router)
Vue.use(ElementUI)

Vue.prototype.$api = Api;
Vue.prototype.$Cookies = Cookies;
Vue.prototype.$common = common;





Vue.config.productionTip = false

const myVue =  new Vue({
  router,
  render: h => h(App),
  i18n
}).$mount('#app')

export default myVue